// extracted by mini-css-extract-plugin
export default {"StrengthSlider":"StrengthSlider_StrengthSlider__C2xPU"};